import { CdkTableModule } from "@angular/cdk/table";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { MaterialModule } from "@app/material.module";
import { LoaderModule } from "@app/shared/loader/loader.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { ComeAndGoSuggestionDialogComponent } from "./come-and-go-suggestion-dialog.component";

@NgModule({
	declarations: [ComeAndGoSuggestionDialogComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		LoaderModule,
		UserAvatarModule,
		TimeInputModule,
		CustomPipesModule,
		CdkTableModule,
	],
})
export class ComeAndGoSuggestionDialogModule {}
